import React, { useEffect, useState } from 'react';
import Input from 'common/components/tags/inputs/Input';
import { AiOutlineRight } from 'react-icons/ai';
import Link from 'common/components/tags/link';
import useHttp from 'common/hooks/useHttp';
import { isEmpty, notEmpty } from 'common/utils/methods';
import { debounceTime } from 'common/utils/constants';
import Overlay from 'common/components/UI/overlay';
import clsx from 'clsx';

export interface props {
  links: { title?: string; href?: string }[];
  searchUrl?: string;
  searchLink?: string;
  placeholder?: string;
  containerClassName?: string;
}
let lockRequest = false;

const Index = ({
  links,
  searchUrl,
  searchLink,
  placeholder,
  containerClassName,
}: props) => {
  const [searchKey, setSearchKey] = useState('');
  const [searchList, setSearchList] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { sendRequest } = useHttp();
  const [isOpenSearchList, setIsOpenSearchList] = useState<boolean>(false);

  useEffect(() => {
    if (isEmpty(searchKey)) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [searchKey]);

  useEffect(() => {
    const time = setTimeout(() => {
      if (lockRequest && notEmpty(searchKey) && searchUrl) {
        fetch();
      }
    }, debounceTime);
    return () => {
      clearTimeout(time);
    };
  }, [searchKey]);

  const fetch = async () => {
    sendRequest({ url: searchUrl + searchKey }, onSuccess);
  };
  const onSuccess = (res: Responsive) => {
    setLoading(false);
    setIsOpenSearchList(true);
    setSearchList(res.data.items);
  };

  const onClear = () => {
    setIsOpenSearchList(false);
    setSearchKey('');
  };

  const handleChange = (e: MyInputEvent) => {
    lockRequest = true;
    setSearchKey(e.target.value);
  };

  return (
    <div className={clsx(containerClassName || 'section-space container')}>
      <Overlay
        active={isOpenSearchList}
        onClick={() => setIsOpenSearchList(false)}
      />
      <div
        className='border-card flex flex-col justify-between
      rounded-3 bg-white p-4 md:flex-row md:rounded-2 md:py-6
      md:px-6 xl:rounded-4 xl:p-8'
      >
        <div className='flex flex-wrap items-center'>
          {links.map((link, index) => (
            <div key={index} className='flex items-center'>
              {link.href ? (
                <>
                  <Link
                    href={link.href}
                    className='py-1 text-[1.2rem] font-semibold text-gray4 xl:text-[1.8rem] xl:font-medium'
                  >
                    {link.title}
                  </Link>
                  <AiOutlineRight
                    color='#D1D6DD'
                    className='mx-[1rem] font-bold'
                  />
                </>
              ) : (
                <h3 className='text-[1.2rem] font-semibold text-primary xl:text-[1.8rem] xl:font-medium normal-case'>
                  {links[links.length - 1].title}
                </h3>
              )}
            </div>
          ))}
        </div>
        {searchLink && searchUrl && (
          <div className='relative'>
            <Input
              name='search'
              type='text'
              value={searchKey}
              onClear={onClear}
              onChange={handleChange}
              loading={loading}
              placeholder={placeholder}
              parentClassName='bg-white xl:w-[40rem]'
              containerClassName='mb-0 mt-4 md:mt-0'
              iconClassName='search text-gray3'
            />
            {isOpenSearchList && (
              <div
                className='border-card absolute left-0 right-0 top-[110%] z-20 max-h-[20rem] w-full overflow-auto 
              rounded-3 bg-white p-4'
              >
                {notEmpty(searchList) ? (
                  searchList.map((item) => (
                    <div className='py-2 first-of-type:pt-0 last-of-type:pb-0'>
                      <Link href={searchLink + '/' + item.id}>
                        {item.title}
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className='flex h-full items-center justify-center'>
                    <p className='text-center'>
                      No results found for this search
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
